import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Se encacarga de listar tipos direcciones
//UserId: id usuario logueado
export const ObtenerTiposDirecciones = (userId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CombosGenericos/TiposDirecciones/', {
            UserId: userId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar tipos direcciones
//UserId: id usuario logueado
export const ObtenerTiposContactos = (userId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CombosGenericos/TiposContactos/', {
            UserId: userId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar las categorias de códigos de sistema
//UserId: id usuario logueado
export const ObtenerCateCodigosSistemas = (userId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CombosGenericos/CateCodigosSistemas/', {
            UserId: userId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar los tipos de CIF
//UserId: id usuario logueado
export const ObtenerTiposCif= (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CombosGenericos/TiposCif/', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar periodos académicos activos
//UserId: id usuario logueado
export const ObtenerPeriodosAcaActivos = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CombosGenericos/Periodos/', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar los idiomas del sistema
//UserId: id usuario logueado
export const ObtenerListaIdiomasSistema = (userId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CombosGenericos/Idiomas/', {
            UserId: userId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};